/* TLB looks video (v1.9). Plays Jennie's own LTK videos straight from LTK's video CDN (Mux / videos-cdn.liketoknow.it);
   nothing is re-hosted. Stills stay underneath as the fallback.
   - Feed cards (.tlb-looks__media[data-vh|data-vp]): muted, looped, inline; a <video> is created only when the card is
     at least 60% in view, paused when it leaves, and torn down once more than MAX_LIVE exist. No autoplay with
     prefers-reduced-motion or Save-Data (the play badge still marks them).
   - Look page / dialog (video[data-tlb-player]): controls, muted autoplay, loop.
   - Source: HLS (adaptive, small renditions for small cards). Native HLS on Safari/iOS; elsewhere hls.js (light build,
     pinned + SRI) is loaded from jsDelivr only when the first video is needed. If HLS fails, falls back to LTK's MP4. */
(function () {
  if (window.TLBVideo) return;
  var HLS_SRC = 'https://cdn.jsdelivr.net/npm/hls.js@1.6.15/dist/hls.light.min.js';
  var HLS_SRI = 'sha384-cO4s3b6E0GCWl1YSZBD7NT1x51lctGv+BncOG55tPsmPrMj/C1jqF0RkutOGwNO9';
  var MAX_PLAYING = 4, MAX_LIVE = 8;
  var ua = navigator.userAgent;
  var isSafari = /^((?!chrome|chromium|crios|fxios|edg|android).)*safari/i.test(ua);
  var hasMSE = !!(window.MediaSource || window.ManagedMediaSource);
  var probe = document.createElement('video');
  var nativeHls = !!probe.canPlayType('application/vnd.apple.mpegurl') && (isSafari || !hasMSE);
  var calm = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || !!(navigator.connection && navigator.connection.saveData);
  var hlsP = null, held = false, live = [], seen = new WeakSet();

  function loadHls() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsP) hlsP = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = HLS_SRC; s.async = true; s.crossOrigin = 'anonymous'; s.integrity = HLS_SRI;
      s.onload = function () { (window.Hls && window.Hls.isSupported()) ? res(window.Hls) : rej(new Error('hls unsupported')); };
      s.onerror = function () { rej(new Error('hls load failed')); };
      document.head.appendChild(s);
    });
    return hlsP;
  }
  function mp4(v, vp) { if (vp) { v.src = vp; } }
  function attach(v, vh, vp, small) {
    if (v._tlb) return v._tlb;
    if (vh && nativeHls) { v.src = vh; return (v._tlb = Promise.resolve()); }
    if (vh && hasMSE) {
      return (v._tlb = loadHls().then(function (H) {
        if (!v._tlb) return;
        var h = new H({ capLevelToPlayerSize: true, startLevel: small ? 0 : -1, maxBufferLength: small ? 8 : 30, maxMaxBufferLength: small ? 12 : 60 });
        v._hls = h;
        h.on(H.Events.ERROR, function (e, d) {
          if (!d || !d.fatal) return;
          h.destroy(); v._hls = null; mp4(v, vp);
          if (v._want) v.play().catch(function () {});
        });
        h.loadSource(vh); h.attachMedia(v);
      }).catch(function () { mp4(v, vp); }));
    }
    mp4(v, vp);
    return (v._tlb = Promise.resolve());
  }
  function detach(v) {
    v._want = false; v._tlb = null;
    try { v.pause(); } catch (e) {}
    if (v._hls) { v._hls.destroy(); v._hls = null; }
    v.removeAttribute('src'); try { v.load(); } catch (e) {}
  }
  function play(v) {
    v._want = true; v.muted = true;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  /* ---- feed cards ---- */
  function playingCount() { return live.filter(function (m) { return m._v && m._v._want; }).length; }
  function startCard(m) {
    if (held || calm) return;
    var v = m._v;
    if (!v) {
      v = document.createElement('video');
      v.className = 'tlb-looks__video';
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'none');
      v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1'); v.setAttribute('disablepictureinpicture', '');
      v.addEventListener('playing', function () { m.classList.add('is-playing'); });
      v.addEventListener('error', function () { m.classList.remove('is-playing'); });
      m.appendChild(v); m._v = v;
    }
    live = live.filter(function (x) { return x !== m; }); live.push(m);
    if (v._want || playingCount() >= MAX_PLAYING) return;
    v._want = true;   /* reserve a slot now; attach() may be async (hls.js) */
    attach(v, m.getAttribute('data-vh'), m.getAttribute('data-vp'), true).then(function () { if (m._in && !held && v._want) play(v); else v._want = false; });
    prune();
  }
  function stopCard(m) { if (m._v) { m._v._want = false; try { m._v.pause(); } catch (e) {} } }
  function kick() { if (held) return; live.slice().forEach(function (m) { if (m._in && !(m._v && m._v._want)) startCard(m); }); }
  function prune() {
    while (live.length > MAX_LIVE) {
      var i = 0; while (i < live.length && live[i]._in) i++;
      if (i >= live.length) break;
      var m = live.splice(i, 1)[0];
      if (m._v) { detach(m._v); m._v.remove(); m._v = null; m.classList.remove('is-playing'); }
    }
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var m = e.target; m._in = e.isIntersecting && e.intersectionRatio >= 0.6;
      if (m._in) startCard(m); else stopCard(m);
    });
    kick();
  }, { threshold: [0, 0.6] }) : null;

  /* ---- look page / dialog player ---- */
  function startPlayer(v) {
    if (v._tlb) return;
    v.addEventListener('playing', function () { v.closest('.tlb-look__photo') && v.closest('.tlb-look__photo').classList.add('is-playing'); });
    attach(v, v.getAttribute('data-vh'), v.getAttribute('data-vp'), false).then(function () { if (!calm) play(v); });
  }

  var api = window.TLBVideo = {
    scan: function (root) {
      root = root || document;
      Array.prototype.forEach.call(root.querySelectorAll('.tlb-looks__media[data-vh], .tlb-looks__media[data-vp]'), function (m) {
        if (seen.has(m) || !io) return; seen.add(m); io.observe(m);
      });
      Array.prototype.forEach.call(root.querySelectorAll('video[data-tlb-player]'), startPlayer);
    },
    /* stop and release every player inside root (dialog close / content swap) */
    release: function (root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('video[data-tlb-player]'), detach);
    },
    /* pause feed videos while a dialog covers them */
    hold: function (on) {
      held = !!on;
      live.forEach(function (m) { if (held) stopCard(m); else if (m._in) startCard(m); });
    },
    _state: function () { return { nativeHls: nativeHls, hasMSE: hasMSE, calm: calm, live: live.length, playing: playingCount() }; }
  };
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) live.forEach(stopCard); else if (!held) live.forEach(function (m) { if (m._in) startCard(m); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { api.scan(document); });
  else api.scan(document);
})();
